import Vue from 'vue'
export default {
  getTemplates(params) {
    return Vue.http.get(`templates`, {params}).then(res => res.body)
  },
  updateTemplate(data) {
    return Vue.http.post(`templates`, data).then(res => res.body)
  }
}
